import React, { FC, useRef } from 'react';
import Styled from './styles';

type TGripper = {
  isDisabled: boolean;
};
const Gripper: FC<TGripper> = ({ isDisabled }) => {
  const gripperRef = useRef<HTMLDivElement>(null);

  return <Styled.Gripper isDisabled={isDisabled} ref={gripperRef} />;
};

export default Gripper;
